import client from '@/configs/client.js'
import Clipboard from 'clipboard'
import NavBar from '@/components/Nav.vue';
import Poster from '@/components/Poster.vue';

export default {
    name: 'PersonalPage',
    components: {
        NavBar,
        Poster
    },
    data() {
        return {
            posterBase64: '',
            shareShow: false,
            giveShow: false,
            serviceShow: false,
            touch: null,
            user: this.$store.state.user
        }
    },
    created() {
        this.$http.get('user/info').then(result => {
            this.user = Object.assign({}, this.$store.state.user, result.data.user);
            this.$store.commit('setUser', this.user);
        })
    },
    methods: {
        posterReady(value) {
            this.posterBase64 = value;
        },
        touchStart() {
            if (client.xinhua) {
                this.touch = setTimeout(() => {
                    let data = {imgbase64: this.posterBase64.substring(this.posterBase64.indexOf('base64,') + 7)};
                    if (client.ios) {
                        window.webkit.messageHandlers.DownloadImg.postMessage(data);
                    } else {
                        /* eslint-disable */
                        xinhuanet.DownloadImg(JSON.stringify(data));
                        /* eslint-enable */
                    }
                }, 1000)
            }
        },
        touchEnd() {
            if (client.xinhua) {
                clearTimeout(this.touch);
            }
        },
        copy() {
            let clipBoard = new Clipboard('#copy')
            clipBoard.on('success', () => {
                clipBoard.destroy()
                clipBoard = new Clipboard('#copy')
                this.$toast('复制成功')
            })
            clipBoard.on('error', () => {
                this.$toast('复制成功')
            })
        }
    }
}